class FostrFormValidation {

  updateFormValidityStatus(form) {

    let fields = form.querySelectorAll('.form--error');
    if (fields.length > 0) {
      form.classList.add('form--invalid');
    } else {
      form.classList.remove('form--invalid');
    }
  }

  setElementValidation(el, message) {

    let field = el.closest('.field');
    if (!field) {
      field = el.closest('.checkbox-field');
    }

    if (message) {
      el.classList.add('invalid');

      if (field) {
        field.classList.add('form--error');
      }
    } else {
      el.classList.remove('invalid');
      if (field) {
        field.classList.remove('form--error');
      }
    }
  }

  getPasswordValidationMessage(password) {

    var isBlank = password.length === 0;
    if(isBlank) {
      return 'The password cannot be blank';
    }

    var lowerCaseLetters = /[a-z]/g;
    if(!password.match(lowerCaseLetters)) {
      return 'The password needs at least one lowercase letter';
    }

    // Validate capital letters
    var upperCaseLetters = /[A-Z]/g;
    if(!password.match(upperCaseLetters)) {
      return 'The password needs at least one capital letter';
    }

    // Validate numbers
    var numbers = /[0-9]/g;
    if(!password.match(numbers)) {
      return 'The password needs at least one number';
    }

    // Validate special characters
    var specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    if(!password.match(specialCharacters)) {
      return 'The password needs at least one special character';
    }

    // Validate length
    if(password.length < 8) {
      return 'The password needs at least 8 characters';
    }

    return false;
  }

  keyup(el) {
    let message = false;
    let form = el.form;
    let fieldTitle = document.querySelector('[for="'+el.id+'"]'); 

    if (el.type === 'password') {
      if (el.classList.contains('confirm-password')) {
        let passwordEl = form.querySelector('[type=password]');
        if (passwordEl.value !== el.value) {
          message = 'The passwords do not match';
        }
      } else {
        if (el.dataset.validate === 'blank') {
          if (el.value.length === 0) {
            message = 'The password cannot be blank';
          }
        } else {
          message = this.getPasswordValidationMessage(el.value);
        }

        if (message) {
          this.setElementValidation(el, message);
        }

        let confirmPasswordEl = form.querySelector('.confirm-password');
        if (confirmPasswordEl) {
          if (confirmPasswordEl.value.length > 0) {
            if (confirmPasswordEl.value !== el.value) {
              this.setElementValidation(confirmPasswordEl, 'Passwords do not match');
            } else {
              this.setElementValidation(confirmPasswordEl, false);
            }
          }
        }
      }
    } else if (el.type === 'email') {
      if (el.required) {
        // check if blank
        if (el.value.length === 0) {
          message = 'The email address is required';
        }
      }
      // check if valid email
      var email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!el.value.match(email)) {
        message = 'Please enter a valid email address';
      }
    } else if (el.type === 'text' || el.type === 'checkbox' || el.type === 'tel' ) {

      if (el.required) {
        // check if blank
        if (el.type === 'checkbox') {
          if (el.checked !== true) {
            message = 'This field is required';
          }
        } else if (el.value.length === 0) {

          let fieldTitleText = '';
          if (fieldTitle) {
            fieldTitle.classList.add('form-field--invalid');
            fieldTitleText = fieldTitle.innerText.toLowerCase().replace('*', '').trim();
            // Capitalize
            fieldTitleText = fieldTitleText.charAt(0).toUpperCase() + fieldTitleText.slice(1);
          } 
          message = `${fieldTitleText} is required`;

        } else {
          if (fieldTitle) {
            fieldTitle.classList.remove('form-field--invalid');
          }
        }
      }
    } else if (el.type === 'select-one') {
      if (el.required) {

        // check if blank
        if (el.value.length === 0 || el.value == "---" ) {

          let fieldTitleText = '';
          if (fieldTitle) {
            fieldTitle.classList.add('form-field--invalid');
            fieldTitleText = fieldTitle.innerText.toLowerCase().replace('*', '').trim();
            // Capitalize
            fieldTitleText = fieldTitleText.charAt(0).toUpperCase() + fieldTitleText.slice(1);
          } 
          message = `${fieldTitleText} is required`;

        } else {
          if (fieldTitle) {
            fieldTitle.classList.remove('form-field--invalid');
          }
        }
      }
    }

    this.createErrorMessageHTML(el,message);
    this.setElementValidation(el, message);
    this.updateFormValidityStatus(form);

    return message;
  }

  createErrorMessageHTML(el,message) {
    let existingErrorEl = el.form.querySelector('.errors');
    if (existingErrorEl) {
      existingErrorEl.remove();
    }

    if (message.length > 0) {
      let html = `<div class="errors"><p>Please correct the following error</p><ul><li>${message}</li></ul></div>`;
      el.form.insertAdjacentHTML('beforeend', html);
    }
  }


  submit(el) {
    let form = el.closest('form');
 
    let fields = form.querySelectorAll('input[type="text"],input[type="tel"],input[type="password"],input[type="email"],input[type="checkbox"],select');

    for (let i = 0; i < fields.length; i++) {

      // Show the first error only
      let field = fields[i];
      if( this.keyup(field) ) {
        return false;
      }
    }

    this.updateFormValidityStatus(form);

  }
}

const fostrFormValidation = new FostrFormValidation();